import { faArchive } from "@fortawesome/free-solid-svg-icons";
import type { FC } from "react";
import { useApi } from "../api/APIContext";
import { useApiCall } from "../api/api";
import type { Inspection } from "../api/dto/Inspection";
import { ModalFooter } from "../components/layout/ModalProvider";

export const ArchiveInspectionModal: FC<{ inspection: Inspection }> = (props) => {
  const { refreshAll } = useApi();
  const { archiveInspection } = useApiCall();
  const confirm = async () => {
    await archiveInspection(props.inspection.id);
    await refreshAll();
  };
  return (
    <>
      <div>Je staat op het punt om de volgende inspectie te archiveren.</div>
      <div className={"font-semibold my-2"}>
        &middot; <span>{props.inspection.name}</span>
      </div>
      <div>Je kunt de inspectie later weer terugzetten.</div>

      <ModalFooter text={"Archiveer"} icon={faArchive} onSubmit={confirm} />
    </>
  );
};
